import { AfterViewInit, Directive, Input } from '@angular/core';
import { IonInput } from '@ionic/angular';

@Directive({
  selector: 'ion-input[appNumberBehavior]'
})
export class IonInputNumberBehaviorDirective implements AfterViewInit {
  @Input('max-decimal') maxDecimal = 2;
  @Input('allow-decimals') allowDecimals = true;
  @Input('max-digits') maxDigits: number | null = null;
  @Input('min') min: number | null = null;

  constructor(private ionInput: IonInput) {}

  async ngAfterViewInit() {
    const inputElement = await this.ionInput.getInputElement();
    inputElement.onkeydown = this.onKeydown.bind(this);
  }

  // This function is used to restrict the input to only numbers and decimals
  onKeydown(ev: KeyboardEvent) {
    const char = ev.key,
      element = ev.target as HTMLInputElement,
      currentValue = element.value,
      currentLength = currentValue.length,
      numberCurrentValue = Number(currentValue),
      decimalValue = currentValue.split('.'),
      decimalLength =
        (Math.floor(numberCurrentValue) !== numberCurrentValue &&
          decimalValue?.length > 1 &&
          decimalValue[1].length) ||
        0;

    //  If the min attribute is set, the input value must be greater than the min value
    if (this.min && !currentLength && Number(char) < this.min) {
      ev.preventDefault();
      return;
    }

    // Allow decimals only if the flag is set
    if (!this.allowDecimals && char === '.') {
      ev.preventDefault();
      return;
    }

    // Allow only the specified number of digits
    if (this.maxDigits !== null && currentLength > this.maxDigits) {
      ev.preventDefault();
      return;
    }

    /*
      checks if the key pressed is either a newline, Enter, Unidentified, Backspace,
      or a number (including decimal point).
      It also ensures that only one decimal point is included and that the number of decimal
      places does not exceed the maximum allowed.
    */
    if (
      /[\n]/.test(char) ||
      char === 'Enter' ||
      char === 'Unidentified' || // This is equivalent to ev.which === 0
      char === 'Backspace' ||
      (/[0-9,'\.]/.test(char) &&
        (char !== '.' || (char === '.' && !currentValue.includes(char))) &&
        (!this.maxDecimal || this.maxDecimal > decimalLength))
    ) {
      return;
    }

    // This condition allows a minus sign (-) to be input only if the input field is empty or if the
    // cursor is at the start and the first character is not already a minus sign.
    if (
      (!currentValue ||
        currentValue === '' ||
        (currentValue[0] !== '-' && element.selectionStart === 0)) &&
      (char === 'Minus' || char === 'NumpadSubtract')
    ) {
      return;
    }

    // other characters are not allowed
    ev.preventDefault();
    ev.stopPropagation();
  }
}
